import React from 'react';
import { MotionConfig } from 'framer-motion';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="35biop8qv8xn0">
      <SalesPage data-id="element-1" data-mp="35eogwwuskfmy" />
    </MotionConfig>;
}